import React, { useEffect, useState } from 'react';
import { formatDatetime, loadFile } from '../../utils/common';
import { createStyles, Grid, makeStyles, Theme } from '@material-ui/core';
import { AppTextfield } from '../parts/input/AppTextfield';
import { AppDatePicker } from '../parts/input/AppDatePicker';

type Tprops = {
  file: File;
  index: number;
  setValue: any;
  deletePicture: (index: number) => void;
};

export const List: React.FC<Tprops> = (props: Tprops) => {
  const { file, index, setValue, deletePicture } = props;

  const classes = useStyles();

  const [image, setImage] = useState<any>(null);

  useEffect(() => {
    // サムネイル表示
    loadFile(file, setImage);

    // ファイルデータをhook-formに追加
    setValue(`list.${index}.upload_file`, file);
  }, [file]);

  return (
    <div style={{ display: 'flex', marginBottom: 20 }}>
      <div>
        <img className={classes.img} src={image} alt='company-seal' />
      </div>
      <div style={{ width: '100%', margin: '0 20px' }}>
        <div className={classes.container} style={{ margin: '10px 0' }}>
          <div style={{ marginRight: 24, width: 50 }}>撮影日</div>
          <AppDatePicker
            name={`list.${index}.shooting_date`}
            defaultValue={formatDatetime(new Date(), 'YYYY-MM-DD')}
          />
        </div>
        <div className={classes.container} style={{ margin: '10px 0' }}>
          <div style={{ marginRight: 24, width: 50 }}>説明</div>
          <AppTextfield
            name={`list.${index}.description`}
            style={{ width: '80%' }}
            multiline={true}
            rows={3}
          />
        </div>
      </div>
      <div
        style={{ cursor: 'pointer', width: 30 }}
        onClick={() => deletePicture(index)}
      >
        {' '}
        ×{' '}
      </div>
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      // モーダルを中央に
      display: 'flex',
      alignItems: 'center'
    },
    img: {
      objectFit: 'cover',
      height: '150px',
      width: '150px'
    }
  })
);
